import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c509d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-list" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = {
  key: 1,
  style: {"height":"100%"}
}

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import SPagination from '@/components/common/pagination/index.vue'
import ProductCard from './ProductCard.vue'
import NoGoods from './NoGoods.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['title', 'data', 'showPagination', 'pageData', 'total', 'type'],
  emits: ['refresh', 'selectRow', 'update:page-data'],
  setup(__props, { expose, emit }) {

const props = __props



const currentPage = computed({
  get () {
    return {
      page: props.pageData.pageNum,
      limit: props.pageData.pageSize
    }
  },
  set (v: any) {
    const { page, limit } = v
    emit('update:page-data', { pageNum: page, pageSize: limit })
    clearScroll()
    emit('refresh')
  }
})
const scrollbarRef = ref()
const clearScroll = () => {
  scrollbarRef.value && scrollbarRef.value.setScrollTop(0)
}

expose({
  clearScroll
})


return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.data?.length > 0)
      ? (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 0,
          ref: (_value, _refs) => {
            _refs['scrollbarRef'] = _value
            scrollbarRef.value = _value
          }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (v) => {
                return (_openBlock(), _createBlock(ProductCard, {
                  key: v,
                  data: v,
                  onSelectRow: _cache[0] || (_cache[0] = ($event: any) => (emit('selectRow', $event)))
                }, null, 8, ["data"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true),
    _createVNode(SPagination, {
      style: {"margin-top":"6px"},
      showPagination: __props.showPagination,
      "page-data": _unref(currentPage),
      "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
      total: __props.total,
      paginationConfig: {
        layout: ' prev, pager, next, sizes, total, jumper',
      }
    }, null, 8, ["showPagination", "page-data", "total"]),
    (__props.data?.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(NoGoods, {
            type: __props.type === 'api' ? 'noSyncGoods' : 'noGoods'
          }, null, 8, ["type"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})